// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__CJPp6","loaderOuter":"PageOverlayLoader_loaderOuter__1QCns"};